import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import * as Styled from './FloatingActionButton.styled';

const TRANSITION_DURATION_ENTER = 200;
const TRANSITION_DURATION_EXIT = 100;

/**
 * Floating Action Buttons are fixed to the bottom of the page with a confirm and reject action
 */
const FloatingActionButton = ({
  title,
  onDisplay,
  onConfirm,
  onReject,
  isDisplayed
}) => {
  useEffect(() => {
    if (isDisplayed) {
      onDisplay();
    }
  }, [isDisplayed]);

  return (
    <Styled.FloatingActionButton data-label="floatingActionButton">
      <CSSTransition
        appear
        in={isDisplayed}
        timeout={{
          enter: TRANSITION_DURATION_ENTER,
          exit: TRANSITION_DURATION_EXIT
        }}
        classNames="animate-up"
        unmountOnExit
      >
        <Styled.FABAnimationContainer
          transitionDurationEnter={TRANSITION_DURATION_ENTER}
          transitionDurationExit={TRANSITION_DURATION_EXIT}
        >
          <Styled.ActionLabel variant="defaultLight" onClick={onConfirm}>
            {title}
          </Styled.ActionLabel>
          <Styled.RejectIcon
            variant="defaultLight"
            data-testid="x_icon"
            onClick={onReject}
          />
        </Styled.FABAnimationContainer>
      </CSSTransition>
    </Styled.FloatingActionButton>
  );
};

FloatingActionButton.propTypes = {
  /**
   * Runs when the Button is displayed
   */
  onDisplay: PropTypes.func,
  /**
   * Runs when user clicks on the button with the label.
   */
  onConfirm: PropTypes.func.isRequired,
  /**
   * Runs when user clicks on the X icon.
   */
  onReject: PropTypes.func.isRequired,
  /**
   * Label for the Floating Action Button.
   */
  title: PropTypes.string.isRequired,
  /**
   * Toggles button visibility.
   */
  isDisplayed: PropTypes.bool
};

FloatingActionButton.defaultProps = {
  isDisplayed: false,
  onDisplay: () => {}
};

export default FloatingActionButton;
